import React from 'react'
import { ExternalLink } from 'components'
import { SEATOW_AUTO_RENEWAL_AGREEMENT_URL } from 'config'

function AutoRenewalConsentContent() {
  return (
    <label>
      I agree to the{' '}
      <ExternalLink
        className="external-link-in-text"
        href={SEATOW_AUTO_RENEWAL_AGREEMENT_URL}
        showIcon={false}
      >
        Sea Tow Automatic Renewal Program Agreement
      </ExternalLink>{' '}
      and understand my membership renews annually at the then-current rate and
      terms. I can change or cancel at any time.
    </label>
  )
}

export default AutoRenewalConsentContent

